"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Content = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var calcMaxWidth = "".concat(parseInt(_encoreFoundation.screenXlMin, 10) - parseInt(_index.sidebarBaseWidth, 10), "px");
var Content = exports.Content = _styledComponents["default"].div.withConfig({
  displayName: "Content",
  componentId: "sc-1n5ckz4-0"
})(["display:flex;flex-direction:column;flex:1;@media (max-width:", "){padding-inline:", ";}@media (min-width:", "){padding-inline:", ";margin-inline-start:", ";max-inline-size:", ";}"], _encoreFoundation.screenXsMax, (0, _index.cssLayoutMargin)('base', '24px'), _encoreFoundation.screenSmMin, (0, _index.cssLayoutMargin)('base', '32px'), function (props) {
  return props.$sidebarWidth || _index.sidebarBaseWidth;
}, function (props) {
  return props.$contentMaxWidth || calcMaxWidth;
});
var _default = exports["default"] = Content;